var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m7.25-4.25V10c0 .25.125.484.334.625l3 2a.75.75 0 0 0 1.041-.21.75.75 0 0 0-.21-1.04L10.75 9.6V5.75A.75.75 0 0 0 10 5a.75.75 0 0 0-.75.75"
  })));
};
export default SvgClock;